<template>
  <v-dialog
    ref="dialog"
    v-model="isDialogOpened"
    :width="width"
    @open="$emit('open')"
  >
    <template
      v-if="!isOpenerHidden"
      v-slot:activator="{ on, attrs }"
    >
      <span v-tooltip="tooltip">
        <v-btn
          :outlined="outlined"
          :color="color"
          :block="block"
          :small="small"
          :text="text"
          :icon="icon"
          :depressed="depressed"
          v-bind="attrs"
          v-on="on"
          :class="activatorClass"
          :disabled="!openable"
        >
          <slot></slot>
        </v-btn>
      </span>
    </template>
    <v-card>
      <v-card-title 
        class="secondary font-weight-bold justify-start white--text"
      >
        <slot name="title"></slot>
      </v-card-title>
      <v-card-text>
        <slot name="contents">
        </slot>
      </v-card-text>
      <slot name="actions">
        <v-card-actions class="pb-5">
          <slot name="buttons">
            <v-spacer />
            <v-btn
              v-if="cancelable"
              color="secondary lighten-5"
              class="mx-3"
              dark
              depressed
              @click="isDialogOpened = false"
            >
              <slot name="cancel">キャンセル</slot>
            </v-btn>
            <v-btn
              v-if="applicable"
              color="secondary"
              depressed
              class="mx-3"
              :disabled="isDisabled"
              @click="$emit('apply'); isDialogOpened = false;"
            >
              <slot name="apply">実行</slot>
            </v-btn>
            <v-spacer />
          </slot>
        </v-card-actions>
      </slot>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  props: {
    tooltip: {
      default: null,
    },
    openable: {
      default: true,
    },
    width: {
      default: null,
    },
    disabled: {
      default: null,
    },
    dialogOnly: {
      default: null,
    },
    activatorClass: {
      default: null,
    },
    outlined: {
      default: null,
    },
    color: {
      default: null,
    },
    block: {
      default: null,
    },
    small: {
      default: null,
    },
    text: {
      default: null,
    },
    icon: {
      default: null,
    },
    depressed: {
      default: null,
    },
    applicable: {
      default: true,
    },
    cancelable: {
      default: true,
    },
  },
  data: function(){
    return {
      isDialogOpened: false,
    }
  },
  computed: {
    isOpenerHidden: function(){
      return this.dialogOnly != null;
    },
    isDisabled: function(){
      return this.disabled
    },
  },
  watch: {
    isDialogOpened: function(newVal){
      if(newVal){
        this.$emit('open');
      }else{
        this.$emit('close');
      }
    },
  },
  methods: {
    close: function(){
      this.isDialogOpened = false;
    },
    open: function(){
      this.isDialogOpened = true;
    }
  },
}
</script>